import { gql } from '@apollo/client';

export const ONBOARDING = gql`
  mutation Onboarding($data: OnboardingInput!) {
    onboarding(data: $data) {
      claimChildAccountTransaction {
        transactionHash
      }
      mintDoodleTransaction {
        transactionHash
      }
      mintPackTransaction {
        transactionHash
      }
    }
  }
`;
